module.exports = __webpack_public_path__ + "img/1568023333.735a014e.jpg";